export const experiments = {
  test: ["control", "test_group_1", "test_group_2"],
  "best-incluencer": ["control", "nadine", "tanja", "sophie", "madleen", "olga"],
} as const

export type Experiments = typeof experiments
export type ExperimentKey = keyof Experiments
export type ExperimentVariant<Key extends ExperimentKey> = Experiments[Key][number]
